
// 税金を計算して返すアクション
// 必要に応じてユーザに国を選択させたりする
export const GET_TAX = "GET_TAX"

// PAYMENTモーダル
export const SHOW_PAYMENT_MODAL = "SHOW_PAYMENT_MODAL"
export const USE_PAYMENT_MODAL  = "USE_PAYMENT_MODAL"
